import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./css/main.login.css";
import Register from "../register/Register";
import SocialMediaIcons from "../../components/SocialMediaIcons";

const Login: React.FC = () => {
  const Cookies = require("js-cookie");
  const navagate = useNavigate();

  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect mobile device
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);


  const handleLogin = async () => {
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    } else if (userName.trim() != "" || password.trim() != "") {
      try {
        Swal.fire({
          title: "Đang xử lý...",
          text: "Vui lòng đợi giây lát",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then((data) => {
            if (data.status === 201 && data.data.user.role === "SUPERADMIN" || data.data.user.role === "ADMIN") {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              navagate("/admin");
            } else {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                text: "Vui lòng đợi ít phút. ",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              navagate("/");
            }

            
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
              })
            );

            // Save token to both Cookie and localStorage
            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: true,
              sameSite: "Strict",
            });
            
            // Also save to localStorage for ApiService
            localStorage.setItem("access_token", data.data.access_token);
            
          })
          .catch((err) => {
            if (err.status === 401) {
              Swal.fire({
                icon: "error",
                title: "Lỗi đăng nhập",
                text: "Tài khoản/mật khẩu không chính xác!",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
            }
          });
      } catch (error) {
        return error;
      }
    }
  };

  return (
    <div className="login-page ">
      <video 
        className="bgLogin" 
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src={isMobile ? "/assets/BG_MOBILE.mp4" : "/assets/BG_PC.mp4"} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div
        className={`model-group ${
          isShowLoginForm || isRegister || isLogin ? "active" : ""
        }`}
      >
        <div className="overlay"></div>

        {/* Login Modal */}
        <div
          className={`model-item model-login ${
            isShowLoginForm || isLogin ? "model-login_active" : ""
          }  `}
        >
          <div
            className="btn-closeModel"
            onClick={() => {
              setIsShowLoginForm(false);
              setIsLogin(false);
            }}
          ></div>
          <p className="miniTxt">Đăng nhập</p>

          <div className="wrapper">
            <div className="title mb-2"></div>
            <form id="loginform" onSubmit={handleLogin}>
              <input
                className="bg-input mb-3"
                type="text"
                id="txtUsername"
                placeholder="Tên đăng nhập"
                onChange={(e) => setUserName(e.target.value)}
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <input
                className="bg-input mb-3"
                type="password"
                id="txtPassword"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <div className="group-btn mt-4">
                <button type="button" className="btn-cancel"></button>
                <button
                  type="button"
                  className="btn-confirm"
                  onClick={handleLogin}
                ></button>
              </div>
            </form>
            <p className="txt-swith">
              Chưa có tài khoản?{" "}
              <span
                className="link-register"
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsRegister(true);
                }}
              >
                Đăng ký ngay
              </span>
            </p>
          </div>
        </div>

        {/* Register Modal */}
        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>

      <div className="index-page_wrapper">
        <div className="logo">
          <div className="wrapper-content">
            <div className="group-btn">
              <div
                className="btn-item btn-login"
                onClick={() => {
                  setIsShowLoginForm(true);
                }}
              ></div>
              <div
                className="btn-item btn-register"
                onClick={() => {
                  setIsRegister(true);
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <SocialMediaIcons />
    </div>
  );
};

export default Login;
